/*!
This file is part of CycloneDX JavaScript Library.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

SPDX-License-Identifier: Apache-2.0
Copyright (c) OWASP Foundation. All Rights Reserved.
*/

export enum Version {
  v1dot7 = '1.7',
  v1dot6 = '1.6',
  v1dot5 = '1.5',
  v1dot4 = '1.4',
  v1dot3 = '1.3',
  v1dot2 = '1.2',
  v1dot1 = '1.1',
  v1dot0 = '1.0',
}

export enum Format {
  XML = 'xml',
  JSON = 'json',
}
